import { render, staticRenderFns } from "./CreateOrderShipmentByCustomerPopUp.vue?vue&type=template&id=0b1ecb1e&scoped=true&"
import script from "./CreateOrderShipmentByCustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipmentByCustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipmentByCustomerPopUp.vue?vue&type=style&index=0&id=0b1ecb1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ecb1e",
  null
  
)

export default component.exports